var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.28564 2.28564L13.7142 13.7142M2.28564 13.7142L13.7142 2.28564","stroke":"#C91616","strokeWidth":"3","strokeLinecap":"round"}));
}

Close.defaultProps = {"className":"close-icon","width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Close;

Close.default = Close;
